import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import classnames from "classnames";
import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";
import NewJobs from "../../components/admin/programming/NewJobs";
import WaitingForProgramming from "../../components/admin/programming/WaitingForProgramming";
import ProgrammingInProgress from "../../components/admin/programming/Programming";
import WaitingForCheck from "../../components/admin/programming/WaitingForCheck";
import Checking from "../../components/admin/programming/Checking";
import ProgrammingComplete from "../../components/admin/programming/ProgrammingComplete";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

const NEW_JOBS_PROGRAMMING_TAB = "NEW_JOBS_PROGRAMMING_TAB";
const WAITING_FOR_PROGRAMMING_TAB = "WAITING_FOR_PROGRAMMING_TAB";
const PROGRAMMING_TAB = "PROGRAMMING_TAB";
const WAITING_FOR_CHECK_TAB = "WAITING_FOR_CHECK_TAB";
const CHECKING_TAB = "CHECKING_TAB";
const PROGRAMMING_COMPLETE_TAB = "PROGRAMMING_COMPLETE_TAB";

const DEFAULT_TABS_TO_LOAD = [
  NEW_JOBS_PROGRAMMING_TAB,
  WAITING_FOR_PROGRAMMING_TAB,
  PROGRAMMING_TAB,
  WAITING_FOR_CHECK_TAB,
  CHECKING_TAB,
  PROGRAMMING_COMPLETE_TAB,
];

const Programming = () => {
  const location = useLocation();
  const [reloadTabs, setReloadTabs] = useState(DEFAULT_TABS_TO_LOAD);
  const [newJobsTotal, setNewJobsTotal] = useState(0);
  const [waitingForProgrammingTotal, setWaitingForProgrammingTotal] =
    useState(0);
  const [programmingTotal, setProgrammingTotal] = useState(0);
  const [waitingForCheckTotal, setWaitingForCheckTotal] = useState(0);
  const [checkingTotal, setCheckingTotal] = useState(0);
  const [programmingCompleteTotal, setProgrammingCompleteTotal] = useState(0);
  const [selectedTab, setSelectedTab] = useState(NEW_JOBS_PROGRAMMING_TAB);

  useEffect(() => {
    if (location.state?.tab) {
      setSelectedTab(location.state.tab);
    }
  }, [location.state]);

  return (
    <Container fluid>
      <Header className="mb-3 ">
        <HeaderTitle className="d-flex flex-column align-items-start">
          <span className="col-12 px-0 col-lg-6 text-dark">
            Jobs In Programming
          </span>
        </HeaderTitle>
      </Header>
      <Row>
        <Col className="flex-grow-1">
          <Nav
            tabs
            className="d-flex text-center flex-nowrap job-details-nav cursor-pointer mt-3"
          >
            <div className="d-flex flex-grow-1">
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === NEW_JOBS_PROGRAMMING_TAB,
                  })}
                  onClick={() => setSelectedTab(NEW_JOBS_PROGRAMMING_TAB)}
                >
                  {`New Jobs (${newJobsTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === WAITING_FOR_PROGRAMMING_TAB,
                  })}
                  onClick={() => setSelectedTab(WAITING_FOR_PROGRAMMING_TAB)}
                >
                  {`Waiting for Programming (${waitingForProgrammingTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === PROGRAMMING_TAB,
                  })}
                  onClick={() => setSelectedTab(PROGRAMMING_TAB)}
                >
                  {`Programming (${programmingTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === WAITING_FOR_CHECK_TAB,
                  })}
                  onClick={() => setSelectedTab(WAITING_FOR_CHECK_TAB)}
                >
                  {`Waiting for Check (${waitingForCheckTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === CHECKING_TAB,
                  })}
                  onClick={() => setSelectedTab(CHECKING_TAB)}
                >
                  {`Checking (${checkingTotal})`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: selectedTab === PROGRAMMING_COMPLETE_TAB,
                  })}
                  onClick={() => setSelectedTab(PROGRAMMING_COMPLETE_TAB)}
                >
                  {`Programming Complete (${programmingCompleteTotal})`}
                </NavLink>
              </NavItem>
            </div>
          </Nav>
          <TabContent activeTab={selectedTab}>
            <TabPane tabId={NEW_JOBS_PROGRAMMING_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <NewJobs
                    setProgrammingTotal={setNewJobsTotal}
                    programmingTotal={newJobsTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={NEW_JOBS_PROGRAMMING_TAB}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={WAITING_FOR_PROGRAMMING_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <WaitingForProgramming
                    setProgrammingTotal={setWaitingForProgrammingTotal}
                    programmingTotal={waitingForProgrammingTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={WAITING_FOR_PROGRAMMING_TAB}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={PROGRAMMING_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <ProgrammingInProgress
                    setProgrammingTotal={setProgrammingTotal}
                    programmingTotal={programmingTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={PROGRAMMING_TAB}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={WAITING_FOR_CHECK_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <WaitingForCheck
                    setProgrammingTotal={setWaitingForCheckTotal}
                    programmingTotal={waitingForCheckTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={WAITING_FOR_CHECK_TAB}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={CHECKING_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <Checking
                    setProgrammingTotal={setCheckingTotal}
                    programmingTotal={checkingTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={CHECKING_TAB}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId={PROGRAMMING_COMPLETE_TAB}>
              <Card className="box-shadow-none border-left border-bottom border-right">
                <CardBody>
                  <ProgrammingComplete
                    setProgrammingTotal={setProgrammingCompleteTotal}
                    programmingTotal={programmingCompleteTotal}
                    setReloadTabs={setReloadTabs}
                    reloadTabs={reloadTabs}
                    tabName={PROGRAMMING_COMPLETE_TAB}
                  />
                </CardBody>
              </Card>
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </Container>
  );
};

export default Programming;
